import { render, staticRenderFns } from "./MensagemSomenteProTeste.vue?vue&type=template&id=473e0f62&"
import script from "./MensagemSomenteProTeste.vue?vue&type=script&lang=js&"
export * from "./MensagemSomenteProTeste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports